import { createContext, useContext, useEffect, ReactNode } from "react";

interface ThemeContextType {
  paletteId: "a";
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    // Set theme only - palette is set per-location in WarmLayout
    document.documentElement.setAttribute("data-theme", "warm-home-like");
  }, []);

  return (
    <ThemeContext.Provider value={{ paletteId: "a" }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) throw new Error("useTheme must be used within ThemeProvider");
  return context;
}
